import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-12 md:py-16 bg-emerald-50" data-id="element-158">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-159">
        <div className="mb-8" data-id="element-160">
          <span className="inline-block px-6 py-2.5 mb-5 rounded-full border border-emerald-200 bg-emerald-100 text-emerald-800 font-bold tracking-[0.15em] uppercase text-xs" data-id="element-161">
            LA SOLUCIÓN DEFINITIVA
          </span>
          <h2 className="font-heading md:text-5xl font-bold text-slate-900 mb-6 max-w-3xl mx-auto text-[28px] leading-tight" data-id="element-162">
            Transformá tu consulta de una charla informativa a una{' '}
            <span className="text-emerald-700" data-id="element-163">
              intervención clínica de alto valor
            </span>
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-164">
          <img src="https://cdn.magicpatterns.com/uploads/jZffEDPzmHH2USTTout28h/Texto_del_parrafo_(10)_(1).webp" alt="Masterpack Protocolos Clínicos de Nutrición" width={800} height={800} loading="lazy" decoding="async" className="w-full h-auto max-w-3xl mx-auto rounded-2xl shadow-xl shadow-emerald-900/5 border border-emerald-200" data-id="element-165" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white border border-emerald-200 rounded-3xl p-8 md:p-10 shadow-sm" data-id="element-166">
          <p className="md:text-xl font-medium text-slate-700 text-[16px] leading-relaxed" data-id="element-167">
            El sistema completo de protocolos clínicos para ahorrar horas de
            trabajo y ofrecer una atención nutricional más profesional desde el
            primer día.
          </p>
        </motion.div>
      </div>
    </section>;
}